/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

/** Two overlapping sheets: the "Copy Link" button (ENH-052). Colour comes from `stroke`. */
function CopyIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.stroke || 'currentColor';

  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="8" y="8" width="14" height="14" rx="2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default CopyIcon;
